
import axios from 'axios'
import $store from '@/store'
import AuthEndpoints from './endpoints/auth'
import UserEndpoints from './endpoints/user'
import ShopEndpoints from './endpoints/shop'
import ProductEndpoints from './endpoints/product'
import CartEndpoints from './endpoints/cart'
import OrderEndpoints from './endpoints/order'
import GlobalEndpoints from './endpoints/global'

export default {

  _endpoints: {
    auth: AuthEndpoints,
    user: UserEndpoints,
    shop: ShopEndpoints,
    product: ProductEndpoints,
    cart: CartEndpoints,
    order: OrderEndpoints,
    global: GlobalEndpoints
  },

  _setAcceptHeader () {
    axios.defaults.headers.common['Accept'] = 'application/json'
  },

  _setAuthHeader () {
    if ($store.getters.auth_get_token !== '') {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + $store.getters.auth_get_token
    } else {
      axios.defaults.headers.common['Authorization'] = ''
    }
  },

  _getHeaders () {
    return {'Accept': 'application/json', 'Authorization': 'Bearer ' + $store.getters.auth_get_token}
  },

  _setContentTypeHeader () {
    axios.defaults.headers.common['Content-Type'] = 'application/json'
  },

  _getUrl (uri, uriParams, withSubdomain) {
    var baseUrl = process.env.APP.api.url
    if (withSubdomain) {
      baseUrl = baseUrl + process.env.APP.api.subdomain
    }
    var url = baseUrl + uri
    if (uriParams) {
      url = url.replace(/%\w+%/g, (all) => {
        return uriParams[all] || all
      })
    }
    return url
  },

  _formCall (endpoint, uriParams, params) {
    var url = endpoint.uri
    if (!endpoint.absouluteUrl) {
      url = this._getUrl(endpoint.uri, uriParams, endpoint.subdomain)
    }
    switch (endpoint.method) {
      case 'GETPDF': return axios.get(url, {params: params, responseType: 'arraybuffer'})
      case 'GET': return axios.get(url, { params: params })
      case 'POST': return axios.post(url, params)
      case 'PUT': return axios.put(url, params)
      case 'DELETE': return axios.delete(url)
    }
  },

  _apiRequest (endpoint, uriParams, params) {
    this._setAuthHeader()
    this._setAcceptHeader()
    this._setContentTypeHeader()
    var api = this
    if (endpoint.loading) {
      $store.commit('OPTIONS_LOADING_STARTED')
    }

    return new Promise((resolve, reject) => {
      if ($store.getters.options_online_status) {
        var accessGranted = endpoint.needsVerified ? $store.getters.auth_get_is_verified : true

        if (accessGranted) {
          api._formCall(endpoint, uriParams, params).then(response => {
            console.log('api._apiRequest ' + endpoint.method + ' ' + endpoint.uri + ' Success')
            console.log(response)
            if (endpoint.loading) {
              $store.commit('OPTIONS_LOADING_ENDED')
            }
            resolve(response.data)
          }, error => {
            console.log('api._apiRequest ' + endpoint.method + ' ' + endpoint.uri + ' Error')
            console.log(error)
            if (endpoint.loading) {
              $store.commit('OPTIONS_LOADING_ENDED')
            }
            if (error.response && error.response.status === 401) {
              var auth = $store.getters.auth_is_authenticated
              if (auth) {
                $store.commit('AUTH_SET_AUTHENTICATED', '')
                window.localStorage.setItem('SESSION_EXPIRED', true)
                window.location.reload(true)
              }
            }
            reject(error)
          })
        } else {
          $store.commit('OPTIONS_LOADING_ENDED')
          $store.commit('OPTIONS_SET_TOAST', 'verify')
          reject(new Error({error_handled: true, error_verified: true}))
        }
      } else {
        $store.commit('OPTIONS_LOADING_ENDED')
        $store.commit('OPTIONS_SET_TOAST', 'connection')
        reject(new Error({error_handled: true, error_connection: true}))
      }
    })
  },

  _mustRefresh () {
    return false
  },

  _saveToken (token) {
    $store.commit('AUTH_SET_AUTHENTICATED', token)
  },

  login (user) {
    var api = this

    var data = {
      username: user.email,
      password: user.password,
      grant_type: 'password',
      client_id: process.env.APP.api.client_id,
      client_secret: process.env.APP.api.client_secret
    }

    return api._apiRequest(api._endpoints.auth.logIn, {}, data)
  },

  logOut () {
    var api = this
    var token = $store.getters.auth_get_token
    return api._apiRequest(api._endpoints.auth.logOut, {'%token%': token}, {})
  },

  saveUser (user) {
    var api = this
    var data = {
      email: user.email,
      password: user.password,
      first_name: user.firstname,
      last_name: user.lastname,
      locale: process.env.APP.locale,
      timezone: process.env.APP.timezone,
      accepts_marketing: user.accepts_marketing
    }
    return api._apiRequest(api._endpoints.user.saveUser, {}, data)
  },

  updateUser (payload) {
    var api = this
    var data = {
      email: payload.email,
      first_name: payload.first_name,
      last_name: payload.last_name,
      accepts_marketing: payload.accepts_marketing
    }
    return api._apiRequest(api._endpoints.user.updateUser, { '%user%': payload.user }, data)
  },

  updatePassword (payload) {
    var api = this
    var data = {password: payload.password}
    return api._apiRequest(api._endpoints.user.updatePassword, { '%user%': payload.user }, data)
  },

  getAddresses (user, limit) {
    var api = this
    return api._apiRequest(api._endpoints.user.getAddresses, { '%user%': user }, {'limit': limit})
  },

  saveAddress (payload) {
    var api = this
    return api._apiRequest(api._endpoints.user.saveAddress, { '%user%': payload.user }, payload.data)
  },

  updateAddress (payload) {
    var api = this
    return api._apiRequest(api._endpoints.user.updateAddress, { '%user%': payload.user, '%address%': payload.address }, payload.data)
  },

  deleteAddress (payload) {
    var api = this
    return api._apiRequest(api._endpoints.user.deleteAddress, { '%user%': payload.user, '%address%': payload.address }, null)
  },

  savePaymentDetail  (hash, token) {
    var api = this
    var data = {
      hash: hash,
      token: token,
      type: 'stripe'
    }
    var user = $store.getters.auth_get_account
    return api._apiRequest(api._endpoints.user.saveCardDetails, { '%user%': user.uid }, data)
  },

  savePaymentDetailIntent () {
    var api = this
    var data = {
      type: 'stripe'
    }
    var user = $store.getters.auth_get_account
    return api._apiRequest(api._endpoints.user.saveCardDetailsIntent, { '%user%': user.uid }, data)
  },

  standardCardDetail (payload) {
    var api = this
    return api._apiRequest(api._endpoints.user.standardCardDetail, {'%user%': payload.user, '%paymentdetail%': payload.paymentDetail}, {})
  },

  getPaymentDetails (limit) {
    var api = this
    var user = $store.getters.auth_get_account
    return api._apiRequest(api._endpoints.user.getCardDetails, { '%user%': user.uid }, {'per_page': limit})
  },

  deletePaymentDetail  (pmUid) {
    var api = this
    var user = $store.getters.auth_get_account
    return api._apiRequest(api._endpoints.user.deleteCardDetails, {'%user%': user.uid, '%paymentdetail%': pmUid}, null)
  },

  getAuthAccount () {
    var api = this
    return api._apiRequest(api._endpoints.auth.getAuthAccount, {}, null)
  },

  getShopList (limit) {
    var api = this
    return api._apiRequest(api._endpoints.shop.getShopList, {}, {'per_page': limit})
  },

  getShopsByCategory (payload, limit) {
    var api = this
    return api._apiRequest(api._endpoints.shop.getShopsByCategory, { '%category%': payload.category }, {'per_page': limit})
  },

  getShopDetails (shop, limit) {
    var api = this
    return api._apiRequest(api._endpoints.shop.getShopDetails, { '%shop%': shop }, {'per_page': limit})
  },

  getShopProductList (payload, limit) {
    var api = this
    var shop
    shop = payload.shop
    return api._apiRequest(api._endpoints.shop.getShopProductList, { '%shop%': shop }, {'per_page': limit, type: 'catalog'})
  },

  getProductList (limit) {
    var api = this
    return api._apiRequest(api._endpoints.product.getProductList, {}, {'per_page': limit, type: 'catalog'})
  },

  getProductDetails (product) {
    var api = this
    return api._apiRequest(api._endpoints.product.getProductDetails, { '%product%': product }, null)
  },

  getLine (line) {
    var api = this
    return api._apiRequest(api._endpoints.user.getLine, {'%line%': line}, null)
  },

  getInLine (shop) {
    var api = this
    var params = {
      'shop_uid': shop
    }
    return api._apiRequest(api._endpoints.user.getInLine, {}, params)
  },

  getOutOfLine (line) {
    var api = this
    return api._apiRequest(api._endpoints.user.getOutOfLine, {'%line%': line}, null)
  },

  getLines (perPage) {
    var api = this
    var user = $store.getters.auth_get_account
    return api._apiRequest(api._endpoints.user.getLines, {'%user%': user.uid}, {'per_page': perPage})
  },

  getCarts (user, perPage) {
    var api = this
    return api._apiRequest(api._endpoints.user.getCarts, {'%user%': user}, {'per_page': perPage})
  },

  getCart (payload) {
    var api = this
    return api._apiRequest(api._endpoints.cart.getCart, { '%cart%': payload.cart }, null)
  },

  getCarriers (shopUid, perPage) {
    var api = this
    return api._apiRequest(api._endpoints.shop.getShopCarriers, {'%shop%': shopUid}, {'per_page': perPage})
  },

  addItemToCart (payload) {
    var api = this
    return api._apiRequest(api._endpoints.cart.addItemToCart, { '%shop%': payload.shop, '%user%': payload.user, '%cartType%': 'catalog' }, payload.item)
  },

  updateItemFromCart (payload) {
    var api = this
    return api._apiRequest(api._endpoints.cart.updateItemFromCart, { '%shop%': payload.shop, '%user%': payload.user, '%item%': payload.item }, payload.amount)
  },

  deleteItemFromCart (payload) {
    var api = this
    return api._apiRequest(api._endpoints.cart.deleteItemFromCart, { '%shop%': payload.shop, '%user%': payload.user, '%item%': payload.item }, null)
  },

  deleteActiveCart (payload) {
    var api = this
    return api._apiRequest(api._endpoints.cart.deleteActiveCart, { '%shop%': payload.shop, '%user%': payload.user, '%cartType%': 'catalog' }, null)
  },

  sendChatMessage (payload) {
    var api = this
    return api._apiRequest(api._endpoints.user.sendChatMessage, {'%cart%': payload.cart}, {'sender_uid': payload.sender, 'message': payload.message, 'receiver_uid': payload.receiver})
  },

  getChatMessages (payload) {
    var api = this
    return api._apiRequest(api._endpoints.user.getChatMessages, {'%cart%': payload.cart}, null)
  },

  getCategories (perPage) {
    var api = this
    return api._apiRequest(api._endpoints.global.getCategories, {}, {'per_page': perPage})
  },

  updateCartAddress (payload) {
    var api = this
    return api._apiRequest(api._endpoints.cart.setAddress, {'%cart%': payload.cart, '%address%': payload.address}, {type: payload.type})
  },

  updateCartPayment (payload) {
    var api = this
    return api._apiRequest(api._endpoints.cart.setPaymentDetail, {'%cart%': payload.cart}, {payment_detail_id: payload.paymentDetail})
  },

  updateCarrier (payload) {
    var api = this
    return api._apiRequest(api._endpoints.cart.setCarrier, {'%cart%': payload.cart}, {carrier_id: payload.carrier})
  },

  getOrder (order) {
    var api = this
    return api._apiRequest(api._endpoints.order.getOrder, {'%order%': order}, {})
  },

  getOrders (user, perPage) {
    var api = this
    return api._apiRequest(api._endpoints.order.getOrders, {'%user%': user}, {'per_page': perPage})
  },

  getInvoicePDF (order) {
    var api = this
    return api._apiRequest(api._endpoints.order.getInvoice, {'%order%': order}, {})
  },

  cartToOrder (cart) {
    var api = this
    return api._apiRequest(api._endpoints.cart.cartToOrder, {'%shop%': cart.shop.uid, '%user%': cart.user.uid, '%cartType%': cart.type}, {
      terms_consent: true,
      rescission_consent: true,
      cart: cart.uid
    })
  },

  resetPassword (payload) {
    var api = this
    return api._apiRequest(api._endpoints.user.resetPassword, {'%token%': payload.token}, payload.params)
  },

  resendVerificationLink () {
    var api = this
    return api._apiRequest(api._endpoints.user.resendVerificationLink, {}, {})
  },

  sendPasswordLink (email) {
    var api = this
    return api._apiRequest(api._endpoints.user.sendPasswordLink, {}, {email: email})
  },

  verifyAccount (payload) {
    var api = this
    return api._apiRequest(api._endpoints.user.verifyAccount, {
      '%token%': payload.token
    }, payload.params)
  },

  sessionStatus (payload) {
    var api = this
    var params = {}
    params[payload.status] = true
    return api._apiRequest(api._endpoints.user.lineStatusChange, {'%line%': payload.line.uid}, {status: params})
  },

  fromPagination (url) {
    var api = this
    var endpoint = api._endpoints.global.fromPagination
    endpoint.uri = url
    console.log(url)
    return api._apiRequest(endpoint, {}, {})
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/api.js